import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Link from '@mui/material/Link';
import { Fragment, useState } from 'react';

import { getMailtoLink } from 'utils';

import Actions from './Actions';
import DeleteLinkedMemberDialog from './DeleteLinkedMemberDialog';

const LinkedMembersTable = ({ rows }) => {
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
	const [deleteDialogData, setDeleteDialogData] = useState();

	const openDeleteDialog = data => {
		setDeleteDialogOpen(true);
		setDeleteDialogData(data);
	};

	const closeDeleteDialog = () => {
		setDeleteDialogOpen(false);
		setDeleteDialogData();
	};

	return (
		<Fragment>
			<TableContainer component={Paper}>
				<Table sx={{ minWidth: 320 }} aria-label="Linked Members">
					<TableHead>
						<TableRow>
							<TableCell sx={{ fontWeight: 600 }}>Member Fullname</TableCell>
							<TableCell sx={{ fontWeight: 600 }} align="right">
								Email
							</TableCell>
							<TableCell sx={{ fontWeight: 600 }} align="right">
								Actions
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map(row => (
							<TableRow key={row.fullname} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell component="th" scope="row">
									{row.fullname}
								</TableCell>
								<TableCell align="right">
									<Link component="a" rel="noopener noreferrer" href={getMailtoLink(row.email)}>
										{row.email}
									</Link>
								</TableCell>
								<TableCell align="right">
									<Actions onDelete={openDeleteDialog} row={row} />
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
			<DeleteLinkedMemberDialog isOpen={deleteDialogOpen} onClose={closeDeleteDialog} data={deleteDialogData} />
		</Fragment>
	);
};

export default LinkedMembersTable;
